// lib/koi-pond-v3/palette.ts
//
// v3 color tokens. Photoreal moonlit pond at night.
// Hex values are the source; `paletteVec3()` emits GLSL vec3 literals
// at build time so shaders never carry raw hex strings.

export const palette = {
  deepWater:        { hex: '#04080c', role: 'Deepest water / fog endpoint' },
  midWater:         { hex: '#0a1820', role: 'Mid-distance water tone' },
  causticPeak:      { hex: '#3a5a6a', role: 'Caustic light pattern peak — cool teal (deliberately NOT warm cream, which was v2 mistake)' },
  causticBase:      { hex: '#08121a', role: 'Caustic dark valley' },
  moonlight:        { hex: '#f5ebd2', role: 'Moonlight key cream' },
  moonHalo:         { hex: '#ffeec2', role: 'Moon halo warm amber' },
  koiPearl:         { hex: '#f4e8d4', role: 'Koi diffuse base — bone china' },
  koiPattern:       { hex: '#d44530', role: 'Kohaku red patches' },
  koiBlack:         { hex: '#0a0606', role: 'Sanke / karasu black markings' },
  koiGold:          { hex: '#c9a253', role: 'Ogon body gold' },
  rimLight:         { hex: '#a8c0d4', role: 'Cool fresnel rim against dark water' },
  lotusDark:        { hex: '#0d1810', role: 'Lotus pad near-silhouette green-black' },
  lotusBud:         { hex: '#2a0e15', role: 'Lotus bud dark crimson' },
  stoneCool:        { hex: '#2a3030', role: 'Foreground stone matte gray-green' },
  fireflyAmber:     { hex: '#ffd070', role: 'Firefly point core' },
  fireflyGlow:      { hex: '#806020', role: 'Firefly halo (additive, dim)' },
  cherryPetal:      { hex: '#f5c8d0', role: 'Falling cherry blossom soft pink' },
  mapleLeaf:        { hex: '#c87838', role: 'Falling maple leaf warm amber' },
  ghostKoi:         { hex: '#f8f4ec', role: 'Rare luminous koi paper-white' },
  ghostRim:         { hex: '#7080a0', role: 'Ghost koi cool blue rim' },
} as const;

export type PaletteKey = keyof typeof palette;

export function paletteVec3(key: PaletteKey): string {
  const hex = palette[key].hex.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;
  return `vec3(${r.toFixed(4)}, ${g.toFixed(4)}, ${b.toFixed(4)})`;
}
